import { render } from "./AlertShortageModal.vue?vue&type=template&id=2c901bc2"
import script from "./AlertShortageModal.vue?vue&type=script&lang=js"
export * from "./AlertShortageModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__